import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const inputWrapperFn = /* @__PURE__ */ createRecipe('input-wrapper', {}, [])

const inputWrapperVariantMap = {}

const inputWrapperVariantKeys = Object.keys(inputWrapperVariantMap)

export const inputWrapper = /* @__PURE__ */ Object.assign(memo(inputWrapperFn.recipeFn), {
  __recipe__: true,
  __name__: 'inputWrapper',
  __getCompoundVariantCss__: inputWrapperFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: inputWrapperVariantKeys,
  variantMap: inputWrapperVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, inputWrapperVariantKeys)
  },
  getVariantProps: inputWrapperFn.getVariantProps,
})